const PROXY_PATH = '/roomeet-quiz-api-proxy';

function getQuizApiOrigin() {
    const raw = (process.env.REACT_APP_API_URL || '').trim();
    if (!raw) return 'https://quiz-api.roomeet.ir';
    try {
        const href = raw.startsWith('http') ? raw : `https://${raw.replace(/^\/\//, '')}`;
        return new URL(href).origin;
    } catch {
        return 'https://quiz-api.roomeet.ir';
    }
}

/** مسیر نسبی فایل داخل upload/files را از URL کامل یا نسبی استخراج می‌کند */
export function extractUploadRelativePath(url) {
    if (!url || typeof url !== 'string') return null;

    const trimmed = String(url).trim();
    if (!trimmed) return null;

    const match = trimmed.match(/upload\/files\/[^\s"'<>?#]+/i);
    if (match) {
        return match[0].replace(/^\/+/, '');
    }

    const normalized = trimmed.replace(/^\/+/, '');
    if (/^upload\/files\//i.test(normalized)) {
        return normalized;
    }

    return null;
}

function buildMediaStreamUrl(relativePath) {
    const apiOrigin = getQuizApiOrigin();
    const query = `path=${encodeURIComponent(relativePath)}`;
    const streamUrl = `${apiOrigin}/api/v1/media/stream?${query}`;

    if (process.env.REACT_APP_SKIP_PDF_DEV_PROXY === 'true') {
        return streamUrl;
    }
    if (process.env.NODE_ENV !== 'development' || typeof window === 'undefined' || !window.location?.origin) {
        return streamUrl;
    }

    return `${window.location.origin}${PROXY_PATH}/api/v1/media/stream?${query}`;
}

/**
 * آدرس فایل رسانه را به endpoint استریم API تبدیل می‌کند تا CORS و Range (Safari/Firefox) درست کار کند.
 */
export function resolveMediaUrl(url) {
    if (!url || typeof url !== 'string') return url;

    const relativePath = extractUploadRelativePath(url);
    if (relativePath) {
        return buildMediaStreamUrl(relativePath);
    }

    let resolved = String(url).trim();
    if (!resolved) return url;

    const apiOrigin = getQuizApiOrigin();

    if (resolved.startsWith('//')) {
        resolved = `https:${resolved}`;
    } else if (resolved.startsWith('/') && !resolved.startsWith('//')) {
        resolved = `${apiOrigin}${resolved}`;
    }

    if (typeof window !== 'undefined' && window.location?.protocol === 'https:' && resolved.startsWith('http://')) {
        resolved = resolved.replace(/^http:/i, 'https:');
    }

    return resolved;
}

/** src تصاویر داخل HTML سوال/گزینه را resolve می‌کند */
export function resolveHtmlEmbeddedMediaUrls(html) {
    if (!html || typeof html !== 'string') return html;
    if (!/<img[\s>]/i.test(html)) return html;

    return html.replace(/(<img\b[^>]*\ssrc=)(["'])([^"']+)\2/gi, (match, prefix, quote, src) => {
        const resolved = resolveMediaUrl(src);
        if (resolved === src) return match;
        return `${prefix}${quote}${resolved}${quote}`;
    });
}
